import { Stack } from "@mui/material";

import { ActorsTable } from "Actors/Components/ActorsTable";
import { NewActorButton } from "Actors/Components/NewActorButton";
import { useCurrentUser } from "Auth/Hooks/useCurrentUser";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { AuthenticatedLayout } from "Shared/Layouts/AuthenticatedLayout";

export const ActorsPage = (): React.ReactNode => {
  const { t } = useResource();
  const { isSysAdmin } = useCurrentUser();

  return (
    <AuthenticatedLayout
      title={t(Resources.Common.Actors)}
      action={!isSysAdmin ? <NewActorButton /> : undefined}
    >
      <Stack spacing={Spacing.L}>
        <ActorsTable />
      </Stack>
    </AuthenticatedLayout>
  );
};
